import Backbone from 'backbone';

let Loader = require('sma.admin/components/loader');

class Collaborators extends Backbone.View {
	initialize(context) {
        this.applicationId = context.applicationId;
        this.setElement($('body'));
	}

    sendInvite(e) {
        let emails = $('#id_email').val().replace(/ /g, '').split(",");;
		let permission = $('#id_role').find('option:selected').text();
		let message = $('#id_message').val();

        let target = $(e.currentTarget);

		this.loader = new Loader(target.closest('.sma-modal'));
		this.loader.show();

		sma.applicants.components.ajax.post({
			url: reverse('collaborator-email-invite', {
				app_id: this.applicationId,
			}),
			data: {'emails': emails, 'permission': permission, 'message': message},
		});
    }

}

module.exports = {
	Collaborators: Collaborators,
}
